import * as React from 'react'
import Split from 'react-split'

import { EditorView } from '@codemirror/basic-setup'
import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import ErrorBoundary from 'modules/core/components/ErrorBoundary'
import { Panes } from 'modules/core/components/Panes'
import { PanesPad } from 'modules/core/components/PanesPad'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { apiClient as ApiClient } from 'modules/core/lib/mobx-rest'

import type { ReportEditorStore } from 'modules/reports/lib/Store'

import Schema from './_Schema'
import Terminal from './_Terminal'
import Visualization from './_Visualization'
import './split.css'
import type { SchemaType } from './types'

const SQL_PLACEHOLDER = `
-- This is a sample query to retrieve employees
-- The SQL database engine behind this feature is Presto 0.217
-- Learn more at https://prestodb.io/docs/current/release/release-0.217.html

SELECT *
FROM employees
WHERE status = 'active'
LIMIT 5
`
interface Props {
  store: ReportEditorStore
  sql?: string | null
}

const Content = ({ store, sql }: Props) => {
  const [query, setQuery] = React.useState(sql ?? store.sqlQuery ?? SQL_PLACEHOLDER)
  const [schema, setSchema] = React.useState<SchemaType[]>([])
  const [editorView, setEditorView] = React.useState<EditorView>()

  const { loading: schemaLoading } = useAsyncData(async () => {
    const api = ApiClient()

    const value = await api.get('/business_intelligence/schema', {
      fields_representation: 'sql_editor',
    })

    setSchema(value)
  }, [])

  React.useEffect(() => {
    store.setSqlQuery(query)
  }, [query, store])

  return (
    <Panes direction="horizontal-2-cols-fixed-left" padding={false}>
      <PanesPad fullHeight>
        <Box gap="s32" height="full">
          <Schema schema={schema} loading={schemaLoading} editorView={editorView} />
        </Box>
      </PanesPad>
      <PanesPad fullHeight>
        <Box>
          <Split className="split" direction="vertical" snapOffset={0} sizes={[30, 70]}>
            <Terminal
              query={query}
              schema={schema}
              onEditorViewChange={setEditorView}
              onQueryChange={setQuery}
            />
            <ErrorBoundary>
              <Visualization store={store} />
            </ErrorBoundary>
          </Split>
        </Box>
      </PanesPad>
    </Panes>
  )
}

export default observer(Content)
